import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { StageDeployApi } from './StageDeployApi';
import { RepoDeployInfo } from './types';

export class StageDeployClient implements StageDeployApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async baseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('stage-deploy');
  }

  async getRepos(): Promise<RepoDeployInfo[]> {
    const url = `${await this.baseUrl()}/repos`;
    const res = await this.fetchApi.fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch repos: ${res.statusText}`);
    }
    return res.json();
  }

  async enableRepo(
    repoName: string,
    project?: string,
  ): Promise<{ prUrl: string; prNumber: number }> {
    const url = `${await this.baseUrl()}/enable`;
    const res = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ repoName, project }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error ?? `Failed to enable: ${res.statusText}`);
    }
    return res.json();
  }

  async disableRepo(
    repoName: string,
  ): Promise<{ prUrl: string; prNumber: number }> {
    const url = `${await this.baseUrl()}/disable`;
    const res = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ repoName }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error ?? `Failed to disable: ${res.statusText}`);
    }
    return res.json();
  }

  async simulateWebhook(
    repo: string,
    tag: string,
  ): Promise<{ updated: boolean }> {
    const url = `${await this.baseUrl()}/simulate`;
    const res = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ repo, tag }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error ?? `Failed to simulate: ${res.statusText}`);
    }
    return res.json();
  }
}
